// @flow

type Props = {
  getCache: (key: string) => Object | null,
  setCache: (key: string, value: Object) => void,
}

const PREFIX = 'zentake_'

const useCache = (): Props => {
  // Function to get cached value from localStorage
  const getCache = (key: string) => {
    if (typeof key !== 'string') throw new Error('Key must be a string')

    try {
      const cachedItem = window.localStorage.getItem(PREFIX + key)
      return cachedItem ? JSON.parse(cachedItem || '{}') : null
    } catch (error) {
      return null
    }
  }

  // Function to set cached value in localStorage
  const setCache = (key: string, value: Object | null) => {
    if (typeof key !== 'string') throw new Error('Key must be a string')
    if (typeof value !== 'object' && value !== null) {
      throw new Error('Value must be an object or null')
    }

    try {
      window.localStorage.setItem(
        PREFIX + key,
        value !== null ? JSON.stringify(value) : null
      )
    } catch (error) {}
  }

  return {
    getCache,
    setCache,
  }
}

export default useCache
